import React from 'react';

// Keeps track of if the interactive is locked for editing and if so, by whom
export default React.createContext({
  lock: {
    id: '',
    owner: '',
    ownerEmail: '',
    isCurrent: false
  },
  setLockedBy: () => {}
});
